import { gql } from "@apollo/client";

export const SAVE_INDICATION = gql`
  mutation saveIndicacion($input: SaveIndicacionInput!) {
    saveIndicacion(input: $input) {
      success
      error
      valorEsperado
    }
  }
`;